import {IComponentOptions} from "angular";
import {ApplicationService} from "../../shared/application/application.service";
import {IModalServiceInstance} from "angular-ui-bootstrap";
import {LoadingService} from "../../shared/loading/loading.service";
import {ApplicationCreditSummary} from "../../shared/model/ApplicationCreditSummary";
import {Assessment} from "../../shared/model/Assessment";

class AcceptCreditModalController {
    public modalInstance: IModalServiceInstance;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public applicationSummary: ApplicationCreditSummary;

    /* @ngInject */
    constructor(private $log: ng.ILogService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.applicationSummary = this.resolve.applicationSummary;
    }

    public accept() {
        this.loadingService.show();

        const assessmentIds = this.applicationSummary.assessments
            .filter((application) => this.applicationSummary.studentResponses[application.id] === Assessment.STUDENT_ACCEPTED)
            .map((assessment) => assessment.id);

        this.applicationService.acceptByStudent(this.applicationSummary.application, assessmentIds)
            .then((updatedApplication) => {
                this.applicationSummary.application = updatedApplication;
                this.toaster.pop({type: "success", title: "Thank you for accepting credit for your Monash University course. Your student record will be updated accordingly. Please check the Web Enrolment System to ensure your credits are correct, and let us know immediately if there is any discrepancy."});
                this.close({$value: updatedApplication});
            }).finally(() => {
            this.loadingService.hide();
        });
    }

    public cancel() {
        this.dismiss({$value: "cancel"});
    }
}

export const AcceptCreditModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: AcceptCreditModalController,
    template: require("./accept-credit-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/accept-credit-modal/accept-credit-modal.component.ts